module.exports = __webpack_public_path__ + "5d7c38d72e18541101f493afc8c2d4da.MP3";